import { CompanySettings } from "../entities/CompanySettings";
import { SettingsRepository } from "../repositories/SettingsRepository";

/** Loads the GST panel. */
export class GetGstSettingsUseCase {
  constructor(private readonly repository: SettingsRepository) {}

  execute(signal?: AbortSignal): Promise<CompanySettings> {
    return this.repository.getGstSettings(signal);
  }
}
